import { useMutation } from '@apollo/client'
import { addPromotionToCart as addPromotionToCartMutation } from 'services/addPromotionToCart'
import { useCart } from 'lib/core/hooks/useCart'

export const useAddPromotionToCart = () => {
  const [addPromoToCart, { data, loading }] = useMutation(addPromotionToCartMutation)
  const { cartId } = useCart()
  const addPromotionToCart = async (sku: string) => {
    return addPromoToCart({
      variables: {
        sku,
        cartId
      }
    })
  }

  return {
    data,
    loading,
    addPromotionToCart
  }
}
